export default __webpack_public_path__ + "70c7a4d.png";